import React from 'react'
import { PostJob } from '../Pages/PostJob/PostJob'

function Postjob() {
  return (
    <>
        <PostJob />
    </>
  )
}

export default Postjob

